window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

const cookieName = '_gdpr-consent';

let cookies = {
  necessary: 0,
  personalization: 0,
  analytics: 0,
  marketing: 0,
};

const currentConsent = {
  ad_storage: null,
  ad_user_data: null,
  analytics_storage: null,
  ad_personalization: null,
};

const consentKeyMap = {
  marketing: ['ad_storage', 'ad_user_data'],
  analytics: ['analytics_storage'],
  personalization: ['ad_personalization'],
};

function initConsentStateFromCookie() {
  const raw = getCookie(cookieName);
    if (!raw) return;
    try {
        const saved = JSON.parse(raw);
        for (const [key, val] of Object.entries(saved)) {
            const gtagKeys = consentKeyMap[key] || [];
            gtagKeys.forEach(gtagKey => {
                currentConsent[gtagKey] = val === 1 ? 'granted' : 'denied';
            });
            $('.category').each(function() {
                let data = $(this).data('tracking');
                if (data == key && data != 'necessary') {
                    if (val !== 1) {
                        $(this).removeClass('active');
                    }
                }
            })
        }
    } catch (e) {
        console.warn("Cookie mal formé", e);
    }
}

function setAcceptAll() {
  $('.category').each(function() {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
        }
    })
    updateCookies()
}

function setConsent(key, value) {
  if (currentConsent[key] === value) return;
  currentConsent[key] = value;

  dataLayer.push({
    event: "default_consent_update",
    consent: { [key]: value },
  });

  gtag("consent", "update", {
    [key]: value,
  });
}

function setMarketing(accepted = true) {
  const val = accepted ? "granted" : "denied";
  setConsent("ad_storage", val);
  setConsent("ad_user_data", val);
}

function setAnalytics(accepted = true) {
  setConsent("analytics_storage", accepted ? "granted" : "denied");
}

function setPersonalization(accepted = true) {
  setConsent("ad_personalization", accepted ? "granted" : "denied");
}

function setCookie(name, value, exdays = 180) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
  hideCookieBar()
}

function getCookie(name) {
  return document.cookie
    .split('; ')
    .reduce((r, v) => {
      const [k, val] = v.split('=');
      return k === name ? decodeURIComponent(val) : r;
    }, "");
}

function updateCookies() {

    $('.category').each(function() {
        let value = $(this).hasClass('active') ? 1 : 0;
        let key = $(this).data('tracking');
        cookies[key] = value
    })
    cookies.necessary = 1

  setCookie(cookieName, JSON.stringify(cookies));

  setMarketing(cookies.marketing === 1);
  setAnalytics(cookies.analytics === 1);
  setPersonalization(cookies.personalization === 1);
}

function showCookieBar() {
    $("#cookie-bar").removeClass("noshow");
}

function hideCookieBar() {
    $("#cookie-bar").addClass("noshow");
}

function showModalGdpr() {
    $(".modal-gdpr").addClass("show");
}

function hideModalGdpr() {
    $(".modal-gdpr").removeClass("show");
}

function updateOldCookies() {
    const raw = getCookie(cookieName);
    if (!raw) return;
    try {
        const saved = JSON.parse(raw);
        const newCookies = {...cookies};

        for (const [key, val] of Object.entries(saved)) {
            switch (key) {
                case "accept":
                    newCookies.necessary = val
                    break;
                case "tracking":
                    newCookies.analytics = val
                    break;
                case "profiling":
                    newCookies.personalization = val
                    break;
                case "remarketing":
                    newCookies.marketing = val
                    break;
                default:
                    newCookies[key] = val
                    break;
            }
        }
        setCookie(cookieName, JSON.stringify(newCookies));
    } catch (e) {
        console.warn("Cookie mal formé", e);
    }
}
// GDPR MODAL - COOKIE BAR 

$(document).ready(function(){

    updateOldCookies();
    initConsentStateFromCookie();

    // Display cookie bar
    if (!getCookie(cookieName)) {
        showCookieBar();
    }

	$('.open-cookie-bar').click(function() {
	  	showCookieBar();
        return false;
	});

    // display modal 
	$('.cookie_infos').click(function() {
        showModalGdpr();
	  	return false;
	});

	$('.close').click(function() {
        hideModalGdpr();
        return false;
	});


	$('.open-cookie').click(function() {
	  	showCookieBar();
	  	return false;
	});

	$('.btn-choice ').click(function() {
		$(this).parents('.category').toggleClass('active');
  });

    // accept all
	$('.accept_cookie').click(function() {
	  	hideCookieBar();
	  	setCookie(cookieName, JSON.stringify({
            necessary: 1,
            personalization: 1,
            analytics: 1,
            marketing: 1,
            }));
        setAcceptAll();
	  	return false;
	});

	$('.btn-save').click(function() {
        updateCookies();
        hideModalGdpr();
        return false;
    });
});